export default __webpack_public_path__ + "static/1422-5e7eb13183535789ba2cd4e288c031a8.gif";